export default "__VITE_ASSET__kPnzX2Wr__";